var useServerEnv = function () {
    var envs = {
        client: {},
        server: {},
    };
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var config = require('config');
    if (config.has('server')) {
        envs['server'] = config.get('server');
    }
    else {
        throw new Error('[RaveJs/Environment Variables] - Cannot found a server key in config files');
    }
    if (config.has('client')) {
        envs['client'] = config.get('client');
    }
    return envs;
};
export default useServerEnv;
//# sourceMappingURL=useServerEnv.js.map